import actionTypes from "../actionTypes";

export function openModal(data) {
  return (dispatch) => {
    const id = data?.modalConfig?.id;
    if (!id) return;
    dispatch({ type: actionTypes.OPEN_MODAL, id, data });
  };
}

export function closeModal(id) {
  return (dispatch) => {
    if (!id) return;
    dispatch({ type: actionTypes.CLOSE_MODAL, id });
  };
}
